import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ILabel } from './label.interface';

@Component({
    selector: 'mlp-ng-label',
    templateUrl: './label.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class LabelSharedComponent {
    @Input() label: ILabel;

    get for(): string { return (this.label.for) ? this.label.for : ''; }
    get subText(): string { return (this.label.optional) ? '(optional)' : (this.label.subText) ? this.label.subText : ''; }
}
